import { PriceIndexCategoryEntity } from '@eastcoal/api/content/interface'
import { queryPriceIndexCategoryPageApi } from '@eastcoal/api/content/priceIndexCategory/queryPriceIndexCategoryPage'

import { RemoteSelect } from '@eastcoal/common/components/RemoteSelect'
import { SelectMode } from '@eastcoal/common/components/RemoteSelect/interface'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { PriceIndexCategorySelectProps } from './interface'

const resolveOptions = (value?: PriceIndexCategoryEntity[]) =>
  value?.map(item => ({ label: item.name, value: item?.id }))

const getOptionValue = (value: PriceIndexCategoryEntity) => `${value.id}`

const priceIndexCategorySelect = <M extends SelectMode>({
  priceIndexType,
  ...selectProps
}: PriceIndexCategorySelectProps<M>) => {
  return (
    <RemoteSelect
      {...selectProps}
      api={queryPriceIndexCategoryPageApi}
      getOptionValue={getOptionValue}
      readyRequest={priceIndexType !== undefined}
      requestParams={{ priceIndexType, pageSize: '30' }}
      resolveOptions={resolveOptions}
    />
  )
}

export const PriceIndexCategorySelect = connect(
  priceIndexCategorySelect,
  mapReadPretty(priceIndexCategorySelect, {
    disabled: true
  })
)
